import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './styles/globals.css';

// ─── TanStack Query Client ────────────────────────────────────────────────────

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 5 minutes stale time by default — individual hooks can override
      staleTime: 5 * 60 * 1000,
      // Don't retry on 401/403 (auth errors)
      retry: (failureCount, error) => {
        if (
          typeof error === 'object' &&
          error !== null &&
          'status' in error &&
          (error.status === 401 || error.status === 403)
        ) {
          return false;
        }
        return failureCount < 2;
      },
      // Disable window focus refetch to reduce noisy requests
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Surface mutation errors to console in dev
      onError: (error) => {
        if (import.meta.env.DEV) {
          console.error('[mutation error]', error);
        }
      },
    },
  },
});

// ─── Mount ────────────────────────────────────────────────────────────────────

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in the DOM');
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
